import { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { Button, TextInput } from "@mantine/core";
import DocumentUpload from "../common/Inputs/DocumentUpload";
import { uploadEmployeeDocument } from "../../api/employeeApi";
import { creationNotification } from "../../utils/useNotification";
import { theme } from "../../theme";
import styled from "styled-components";

const DocumentUploadPage = () => {
  const { id }: any = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const uploadTargetDocId = searchParams.get("docId") || null;
  const defaultName = searchParams.get("docName") || "";

  const [file, setFile] = useState<any>(null);
  const [name, setName] = useState<string>(defaultName);
  const [loading, setLoading] = useState(false);

  const isRequiredDoc = !!uploadTargetDocId;

  const handleSave = async () => {
    if (!file || !name.trim()) return;
    try {
      setLoading(true);
      const { data }: any = await uploadEmployeeDocument({
        employeeId: id,
        file,
        name,
        fileId: uploadTargetDocId || undefined,
      });
      if (data?.success) {
        creationNotification("Belge", true);
        navigate(`/employees/${id}`, { state: { tab: "documents" } });

      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper>
      <Header>
        <Title>Özlük Belgesi Yükleme</Title>
        <BackButton onClick={() => navigate(`/employees/${id}`, { state: { tab: "documents" } })}>
          ← Geri Dön
        </BackButton>
      </Header>

      <FormCard>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <TextInput
            label="Dosya Adı"
            placeholder="Dosya adı giriniz."
            value={name}
            onChange={(e) => setName(e.currentTarget.value)}
            required
            readOnly={isRequiredDoc}
          />
          <DocumentUpload onFileSelect={setFile} />
        </div>

        <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "24px" }}>
          <Button variant="default" onClick={() => navigate(`/employees/${id}`, { state: { tab: "documents" } })}>
            Vazgeç
          </Button>
          <Button
            color={theme.colors.brand.normal}
            onClick={handleSave}
            disabled={!file || !name.trim() || loading}
            loading={loading}
          >
            Kaydet
          </Button>
        </div>
      </FormCard>
    </PageWrapper>
  );
};

export default DocumentUploadPage;

const PageWrapper = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.div`
  font-weight: 600;
  color: black;
  font-size: 20px;
  line-height: 24px;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
  &:hover {
    color: black;
  }
`;

const FormCard = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
  max-width: 600px;
`;